import { accountSettingsRoutes } from './accounts';

export const settingsRoutes = [
  {
    path: 'settings',
    children: [...accountSettingsRoutes],
  },
];
